import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { Header } from './header';
import { Layout } from './layout';

/**
 * Route-owned pending UI for the www content pages, set as each route's `pendingComponent`.
 * These routes read their stats/content through suspense queries at the top of the component,
 * so without this they fall through to the router-wide default and render nothing at all
 * while the data loads. The real `<Header />` is kept (it has no data dependency), and the
 * content area gets a generic title-and-paragraphs skeleton wide enough to fit every page.
 */
export function WwwPagePending() {
	return (
		<Layout>
			<Header />
			<div className="mx-auto flex max-w-[1310px] flex-col gap-4 px-4 py-16">
				<Skeleton className="mb-4 h-12 w-80" />
				{Array.from({ length: 8 }).map((_, index) => (
					// oxlint-disable-next-line react/no-array-index-key
					<Skeleton key={index} className={index % 4 === 3 ? 'h-5 w-2/3' : 'h-5 w-full'} />
				))}
			</div>
		</Layout>
	);
}
